module.exports = {
  tbmobile: {
    title: "二甲双胍",
    traceability: "商品溯源",
    details: "查看详情",
    medicinebox: "家庭药盒",
    checkbox: "查看全部药单",
    binding: "用户绑定",
    relatives: "我的亲属",
    doctor: "我的医生",
    catalog: "目录",
    content: "内容",
    retrieval: "检索",
    captionRetrieval: "字幕检索",
    noCaption: "没有检索到相关字幕",
    loading: "请稍后",
    video: "医疗跳播"
  },
  toorigins: {
    title: "二甲双胍",
    traceCode: "追溯码：81325160499913080328",
    details: "商品详情>",
    validation: "药品验证",
    normal: "正常",
    productionDate: "生产日期",
    expiryDate: "有效期至",
    usageAnddosage: "用法用量",
    usage: "口服。一次6片，一日2次",
    scanRecord: "扫码记录",
    scanDetails: "详情",
    scanResult: "仅5人扫码，属于正常范围",
    company: "云南白药集团股份有限公司"
  },
  medBox: {
    title: "我的药盒",
    CVS: "二甲双胍",
    VC: "维生素C银翘片",
    huanglian: "黄连上清片",
    chaihu: "小柴胡颗粒",
    productionbatch: "生产批次",
    productionDate: "生产日期",
    expiryDate: "有效期至",
    usageAnddosage: "用法用量",
    usage: "口服。一次6片，一日2次"
  },
  myDoc: {
    title: "我的医生",
    doc1: "张智伟",
    skill: "小儿心脏病专家",
    company: "广东省人民医院心血管病研究所"
  },
  userbind: {
    title: "用户绑定",
    phone: "手机号",
    tips: "请输入手机号码",
    button: "绑定用户，并发送吃药提醒",
    loading: "正在发送，请稍后。。。",
    success: "发送成功",
    failure: "发送延时，请稍后重试"
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js